const PASSPORT_LOGIN_PATH = "/login-phone?redirectTo=/passport&journey=audience_passport&requiresOnboarding=false";

export const getPassportCta = (user) => user
  ? { label: "Open My Passport", to: "/passport" }
  : { label: "Get my free passport", to: PASSPORT_LOGIN_PATH };

export const getHeaderAuthCta = (user) => user
  ? { label: "My Passport", to: "/passport" }
  : { label: "Login / Signup", to: PASSPORT_LOGIN_PATH };
